import { randomCave } from './RandomCave.js'
import { randomDungeon } from './RandomDungeon.js'
import { randomSimplexMap } from './RandomSimplex.js'

export default {
	randomCave,
	randomDungeon,
	randomSimplexMap
}



// WEBPACK FOOTER //
// ./src/assets/js/game/map/generation/index.js